<template>
  <div>
    <h2 class="content-block">Dxlookup Value Changed Datagrid</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div>
          <div class="dx-fieldset">
            <div class="dx-field">
              <DxLookup
                :items="items"
                :display-expr="getDisplayExpr"
                :apply-value-mode="applyValueMode"
                placeholder="Select employee"
                :input-attr="{ 'aria-label': 'Lookup' }"
                @value-changed="setSelectedValue"
              >
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </div>
          </div>
          <div v-if="selectedValue">
            <div class="selected">
              <div class="frame">
                <img id="selected-employee-img" :src="selectedValue.Picture" />
              </div>
              <div id="selected-employee-notes">{{ selectedValue.Notes }}</div>
            </div>
          </div>
          <div class="options">
            <div class="caption">Options</div>
            <div class="option">
              <div class="label">Apply Value Mode</div>
              <DxSelectBox
                :items="applyValueModes"
                :input-attr="{ 'aria-label': 'Apply Value Mode' }"
                v-model:value="applyValueMode"
              />
            </div>
          </div>
        </div>

        <DxDataGrid
          :data-source="dataSource"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          key-expr="id"
          @option-changed="onOptionChanged"
          @saving="onSaving"
          @saved="onSaved"
          @row-removed="onRemoved"
        >
          <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            mode="row"
          />
          <dxColumn data-field="id" caption="riwayatkeluargaid"></dxColumn>
          <dxColumn data-field="pegawai_id" caption="pegawaiId"></dxColumn>
          <dxColumn data-field="pegawai.nik" caption="NIK pegawai"></dxColumn>
          <dxColumn data-field="pegawai.nama" caption="nama pegawai"></dxColumn>
          <dx-column data-field="nama" caption="nama anggota keluarga">
          </dx-column>

          <dx-column data-field="keluarga_hub_id" caption="Keluarga Hub">
            <DxLookupDatagrid
              display-expr="nama"
              value-expr="id"
              :data-source="keluargaHubSource"
              @value-changed="setSelectedValue"
              :apply-value-mode="applyValueMode"
            />
          </dx-column>

          <dx-column data-field="pasangan_id" caption="NIK Pegawai PDAM">
            <DxLookupDatagrid
              display-expr="nik"
              value-expr="id"
              :data-source="pegawaiSource"
            />
          </dx-column>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import axios from "axios";
import { DxLookup, DxDropDownOptions } from "devextreme-vue/lookup";
import { DxSelectBox } from "devextreme-vue/select-box";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxLookup as DxLookupDatagrid,
} from "devextreme-vue/data-grid";
import _ from "lodash";
import { employees } from "./data-dxlookup-value-changed.js";

const pegawaiSource = new ODataStore({
  type: "odata",
  url: "http://127.0.0.1/odata/SimpegPegawais",
  key: "id",
  sort: "nik desc",
  version: 4,
  beforeSend: function (e) {
    e.headers = {
      "odata-version": "4.0",
    };
    if (e.method === "PUT") e.method = "PATCH";
    e.params.$orderby = "nik desc";
  },
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookupDatagrid,
    DxLookup,
    DxDropDownOptions,
    DxSelectBox,
  },
  data() {
    return {
      pegawaiSource,
      focusedRowKey: null,
      items: employees,
      selectedValue: null,
      applyValueModes: ["instantly", "useButtons"],
      applyValueMode: "instantly",
      dataSource: null,
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),
    };
  },
  async mounted() {
    this.dataSource = this.fetchDatarKeluarga();
  },
  methods: {
    async onRemoved(e) {
      if (
        e.data.pasangan_id !== null &&
        (e.data.keluarga_hub_id == 2 || e.data.keluarga_hub_id == 3)
      ) {
        await this.sinkronPasanganDeleted(e.data);
      }
    },

    async sinkronPasanganDeleted(request) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      await axios.post(
        "http://127.0.0.1/api/sinkron_pasangan_deleted",
        request,
        config
      );
    },
    async onSaving(e) {
      var pasangan_id_baru = null;
      var keluarga_hub_id_baru = null;
      if (_.has(e.changes[0]["data"], "keluarga_hub_id")) {
        keluarga_hub_id_baru = _.get(e.changes[0]["data"], "keluarga_hub_id");
      }

      if (_.has(e.changes[0]["data"], "pasangan_id")) {
        pasangan_id_baru = _.get(e.changes[0]["data"], "pasangan_id");
        //ada perubahan pasangan_id, lakukan sinkron
        const dataSource = e.component.getDataSource();
        const dataLama = dataSource
          .items()
          .find((item) => item.id === e.changes[0]["key"]);
        var pasangan_id_lama = dataLama.pasangan_id;
        if (pasangan_id_lama !== null) {
          //lakukan sinkron
          await this.sinkronPasanganSaving(
            pasangan_id_lama,
            pasangan_id_baru,
            dataLama.pegawai_id,
            this.yangManaYa(keluarga_hub_id_baru, dataLama.keluarga_hub_id)
          );
        } else {
          //tidak lakukan sinkron, karena data lama memang tidak punya pasangan_id,
          //tidak perlu melakukan perubahan di tabel pasangan
        }
      }
      // e.changes.forEach((item) => {
      //   sinkron = _.has(item["data"], "pasangan_id");
      //   if (sinkron) {
      //     pasangan_id_baru = _.get(item["data"], "pasangan_id");
      //   }
      // });

      // e.changes.forEach((item) => {
      //   found = _.has(item["data"], "keluarga_hub_id");
      //   if (found) {
      //     keluarga_hub_id_baru = _.get(item["data"], "keluarga_hub_id");
      //   }
      // });

      // console.log("pasangan_id_baru", pasangan_id_baru);
      // if (sinkron) {
      //   //ada perubahan pasangan_id, lakukan sinkron
      //   const dataSource = e.component.getDataSource();
      //   const dataLama = dataSource
      //     .items()
      //     .find((item) => item.id === e.changes[0]["key"]);
      //   var pasangan_id_lama = dataLama.pasangan_id;
      //   if (pasangan_id_lama !== null) {
      //     //lakukan sinkron
      //     await this.sinkronPasanganSaving(
      //       pasangan_id_lama,
      //       pasangan_id_baru,
      //       dataLama.pegawai_id,
      //       this.yangManaYa(keluarga_hub_id_baru, dataLama.keluarga_hub_id)
      //     );
      //   } else {
      //     //tidak lakukan sinkron, karena data lama memang tidak punya pasangan_id,
      //     //tidak perlu melakukan perubahan di tabel pasangan
      //   }
      //   console.log("pasangan_id_lama", pasangan_id_lama);
      // }

      e.cancel = false;
      // console.log("onSaving after cancel false", e);
    },

    yangManaYa(baru, lama) {
      if (baru !== null) return lama;
      return baru;
    },
    async onSaved(e) {
      await this.sinkronPasanganSaved(e.changes[0]["data"]);
    },

    async sinkronPasanganSaved(request) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      await axios.post(
        "http://127.0.0.1/api/sinkron_pasangan_saved",
        request,
        config
      );
    },

    async sinkronPasanganSaving(
      pasangan_id_lama,
      pasangan_id_baru,
      pegawai_id,
      keluarga_hub_id
    ) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      var data = {
        pasangan_id_lama: pasangan_id_lama,
        pasangan_id_baru: pasangan_id_baru,
        pegawai_id: pegawai_id,
        keluarga_hub_id: keluarga_hub_id,
      };
      await axios.post(
        "http://127.0.0.1/api/sinkron_pasangan_saving",
        data,
        config
      );
    },

    namaPasanganBerubah(value, previousValue) {
      var ubah = false;
      if (value.length > 0) {
        if (_.has(value[0]["data"], "pasangan_id")) {
          ubah = true;
          if (previousValue.length > 0) {
            ubah = false;
            if (_.has(previousValue[0]["data"], "pasangan_id")) {
              if (
                _.get(value[0]["data"], "pasangan_id") !==
                _.get(previousValue[0]["data"], "pasangan_id")
              ) {
                ubah = true;
              }
            }
          }
        }
      }

      return ubah;
    },

    async onOptionChanged(e) {
      if (e.fullName === "focusedRowKey") {
        this.focusedRowKey = e.value;
      }
      if (e.fullName === "editing.changes") {
        if (this.namaPasanganBerubah(e.value, e.previousValue)) {
          const selectedItem = await this.pegawaiSource.byKey(
            _.get(e.value[0]["data"], "pasangan_id")
          );
          const rowIndex = e.component.getRowIndexByKey(this.focusedRowKey);
          e.component.cellValue(rowIndex, "nama", selectedItem.nama);
        }
      }
    },
    getDisplayExpr(item) {
      return item ? `${item.FirstName} ${item.LastName}` : "";
    },
    setSelectedValue(e) {
      this.selectedValue = e.value;
    },
    fetchDatarKeluarga() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: "http://127.0.0.1/odata/RiwayatKeluargas",
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),

        expand: ["pasangan", "pegawai"],
      });
      return odataStore;
      // const data = await odataStore.load({});
      // return data;
    },
  },
};
</script>
